export interface Props {
  theme: Theme,
}

/**
 * This enum also contains captions for the icons. This is seemingly odd usage, but it works.
 * [key] = [caption]
 * Captions are displayed below icons on the front end.
 */
export enum Theme {
  age = 'Age',
  creditHistory = 'Credit History',
  drivingRecord = 'Driving Record',
  gender = 'Gender',
  highRisk = 'High-Risk Violations',
  license = 'A Valid Driver’s License',
  makeAndModel = 'Car Make and Model',
  maritalStatus = 'Marital Status',
  mileage = 'The Car’s Mileage',
  vin = 'VIN Number',
  zip = 'Your Zip Code',
  burglary = 'Burglaries or damage to personal belongings',
  burstPipe = 'Frozen pipes that burst',
  fallingTree = 'Falling trees or other objects that hit the structure',
  fire = 'Damage from fires and smoke',
  hvac = 'Water damage from a broken water heater, HVAC system, or other appliances',
  injury = 'Lawsuits from people who get injured on your property',
  wind = 'Wind or hail damage',
  computerDamage = 'Damage to business property',
  letterA = 'You are not currently enrolled in Medicare',
  letterB = 'Have a qualifying life event',
  letterC = 'Are working past the age of 65',
  birthCertificate = 'Birth certificate',
  driversLicense = 'Driver’s license or state-issued ID card',
  militaryID = 'Government-issued military ID',
  passport = 'Current/valid U.S passport',
  cake = 'Age',
  health = 'Health',
  location = 'Location',
  occupation = 'Occupation',
  period = 'Benefits period',
  salary = 'Salary',
}
